export enum FormNameEnums {
    CHEF_IT_FORM = 'ChefItForm',
    CLEAN_IT_FORM = "CleanItForm"
}
